const performMutationWithLog = async (apolloClient, variables, mutation) => {
  try {
    await apolloClient.mutate({
      mutation,
      variables,
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export default performMutationWithLog;
